module.exports = __webpack_public_path__ + "static/media/Cuboid.454b9e99.jpg";